module.exports = __webpack_public_path__ + "media/styles/images/png/checkbox-unchecked-teal-39e2fa4b84364a4cd2d6cdf3e625f358.png";